import { useAppSelector } from '.';
import { Language } from '../../enums';


export const useTranslate = () => {
    const language = useAppSelector(state => state.translation.language);

    return (translations: string[], placeholder?: string | number, requiredLanguage?: Language) =>
        translations &&
            (placeholder ?
                translations[requiredLanguage ?? language].replace('${x}', placeholder.toString()) :
                translations[requiredLanguage ?? language]);
};
